<template>
    <div class="content-header">
        <table class="table table-header">
            <tr>
                <td>
                    <div class="tb-cnt-tr">
                        <label class="tb-cnt-lb">{{$t('tour.tour_number')}}</label>
                        <div class="tb-cnt-txt"><div v-if="tourInfo.tour_number" v-html="tourInfo.tour_number"></div></div>
                    </div>
                </td>
                <td>
                    <div class="tb-cnt-tr">
                        <label class="tb-cnt-lb">{{$t('tour.departure_date')}}</label>
                        <div class="tb-cnt-txt"><div v-if="tourInfo.departure_date" v-html="dateUtils.formatDateYYYYMMDD(tourInfo.departure_date)"></div></div>
                    </div>
                </td>
                <td>
                    <div class="tb-cnt-tr">
                        <label class="tb-cnt-lb">{{$t('tour.person_count')}}</label>
                        <div class="tb-cnt-txt"><div v-if="tourInfo.person_count" v-html="showPersonNumber(tourInfo.person_count, $t('tour.person'))"></div></div>
                    </div>
                </td>
            </tr>

            <tr>
                <td>
                    <div class="tb-cnt-tr">
                        <label class="tb-cnt-lb">{{$t('tour.tour_name')}}</label>
                        <div class="tb-cnt-txt"><div v-if="tourInfo.name" v-html="tourInfo.name"></div></div>
                    </div>
                </td>
                <td>
                    <div class="tb-cnt-tr">
                        <label class="tb-cnt-lb">{{$t('tour.return_date')}}</label>
                        <div class="tb-cnt-txt"><div v-if="tourInfo.return_date" v-html="dateUtils.formatDateYYYYMMDD(tourInfo.return_date)"></div></div>
                    </div>
                </td>
                <td>
                    <div class="tb-cnt-tr">
                        <label class="tb-cnt-lb">{{$t('tour.conductor_number')}}</label>
                        <div class="tb-cnt-txt"><div v-if="tourInfo.conductor_number" v-html="showPersonNumber(tourInfo.conductor_number, $t('tour.person'))"></div></div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import StorageService from "@/services/common/storage.service";
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';

export default {
    name: "PCTourInfo",
    components: {},
    props: {
        tourInfoProp: {},
    },
    data () {
        return {
            utils: Utils,
            dateUtils: DateUtils,
            tourInfo: {},
        };
    },
    created () {
        // if (Utils.isEmptyObj(this.tourInfoProp)){
        this.getData();
        // }
    },
    methods: {
        showPersonNumber (number, text = "") {
            return number + text;
        },
        getData () {
            let tourInfo = JSON.parse(StorageService.getTour());
            if (!Utils.isEmptyObj(tourInfo)) {
                this.tourInfo = tourInfo;
            } else this.tourInfo = {};
        },
    },
    watch: {
        tourInfoProp: function tourInfoProp (newVal, oldVal) {
            this.tourInfo = this.tourInfoProp;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/layout/pc/Tour/Info.vue